import { render, staticRenderFns } from "./DetectStyle.vue?vue&type=template&id=79938a86&scoped=true&"
import script from "./DetectStyle.vue?vue&type=script&lang=js&"
export * from "./DetectStyle.vue?vue&type=script&lang=js&"
import style0 from "./DetectStyle.vue?vue&type=style&index=0&id=79938a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79938a86",
  null
  
)

export default component.exports